import { render, staticRenderFns } from "./IntegratedRetail.vue?vue&type=template&id=7d8194cd&scoped=true"
import script from "./IntegratedRetail.vue?vue&type=script&lang=js"
export * from "./IntegratedRetail.vue?vue&type=script&lang=js"
import style0 from "./IntegratedRetail.vue?vue&type=style&index=0&id=7d8194cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8194cd",
  null
  
)

export default component.exports